import { useState } from "react";

export default function useChangeAllDescriptionsDialog() {
  const [openChangeAllDescriptionsDialog, setOpenChangeAllDescriptionsDialog] =
    useState(false); // for the confirm Change All descriptions dialog

  const [changeAllDescriptions, setChangeAllDescriptions] = useState(false); // This state holds the user's choice

  const [
    ChangeAllDescriptionsDialogShown,
    setChangeAllDescriptionsDialogShown,
  ] = useState(false); // This flag indicates whether the Dialog has been shown

  function countDescriptionInstances(deeds, description) {
    return deeds.reduce((count, deed) => {
      // Assuming the description is a property of the deed object
      return deed.description === description ? count + 1 : count;
    }, 0);
  }

  return {
    openChangeAllDescriptionsDialog,
    setOpenChangeAllDescriptionsDialog,
    changeAllDescriptions,
    setChangeAllDescriptions,
    ChangeAllDescriptionsDialogShown,
    setChangeAllDescriptionsDialogShown,
    countDescriptionInstances,
  };
}
